import { render, staticRenderFns } from "./CustomerComplaintSales.vue?vue&type=template&id=a953b9b8&"
import script from "./CustomerComplaintSales.vue?vue&type=script&lang=js&"
export * from "./CustomerComplaintSales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports